module.exports = __webpack_public_path__ + "img/communication.466cabf4.svg";